/**
 * Headers for calls to our own `/api/*` Functions.
 *
 * ── WHY THE TOKEN IS NOT IN `Authorization` ───────────────────────────────
 * Azure Static Web Apps REPLACES the Authorization header on requests it
 * proxies to the managed Functions backend with an internal token of its own
 * (aud=https://<id>.azurewebsites.net/azurefunctions). The user's MSAL token
 * never arrives, so the Function was verifying Azure's infrastructure token
 * against Entra and refusing it — which reads exactly like a misconfigured
 * tenant id, and was diagnosed only once the 401 started reporting the claims
 * it had actually seen.
 *
 * So the token travels in a header SWA leaves alone. Authorization is still
 * sent as well: harmless in production, and it keeps local dev working on
 * hosts that pass it through untouched.
 *
 * Mirrors `api/src/shared/clientToken.ts` — the two must agree.
 */

export const CLIENT_TOKEN_HEADER = "x-isynergy-token";

/** Auth headers for a fetch to `/api/*`, or `{}` when there is no token. */
export function apiAuthHeaders(token: string | null): Record<string, string> {
  if (!token) return {};
  return {
    [CLIENT_TOKEN_HEADER]: token,
    Authorization: `Bearer ${token}`,
  };
}
